import crudActions from '@/store/crudActions'
import axios from '@/libs/axios'

const endpoint = 'confirmed-scientific-topic-protocol'
const Actions = crudActions(endpoint)

const toFormData = protocol => {
  const formData = new FormData()
  formData.append('protocol_number', protocol.protocol_number)
  formData.append('protocol_date', protocol.protocol_date)
  if (protocol.file_upload instanceof File) formData.append('file', protocol.file_upload)
  return formData
}

const createOrUpdate = (ctx, protocol) => new Promise((resolve, reject) => {
  const request = axios.post(`/${endpoint}/`, toFormData(protocol))

  request
    .then(response => {
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})

Actions.create = createOrUpdate

export default {
  ...Actions,
  createOrUpdate,
}
